/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { tunneledMcpGetServer } from "../funcs/tunneledMcpGetServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { TunneledMcpServer } from "../models/components/tunneledmcpserver.js";
import {
  GetTunneledMcpServerRequest,
  GetTunneledMcpServerSecurity,
} from "../models/operations/gettunneledmcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type GetTunneledMcpServerQueryData = TunneledMcpServer;

export function prefetchGetTunneledMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetTunneledMcpServerRequest,
  security?: GetTunneledMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetTunneledMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetTunneledMcpServerQuery(
  client$: GramCore,
  request: GetTunneledMcpServerRequest,
  security?: GetTunneledMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetTunneledMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyGetTunneledMcpServer({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function getTunneledMcpServerQueryFn(
      ctx,
    ): Promise<GetTunneledMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(tunneledMcpGetServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetTunneledMcpServer(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "tunneledMcp", "getServer", parameters];
}
